import axios from 'axios';

const GetHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
};

export default class LiteralsApi {
    constructor(url) {
        this.url = url;
    }

    getLiterals = (lang, implId) =>
        axios
            .get(`${this.url}&language=${lang}&implementationCode=${implId}`, {
                headers: {
                    ...GetHeaders,
                },
            })
            .then((response) => response.data);
}
